<div class="avatar-container">
  <img
    class="avatar"
    [src]="shouldShowRepostedAuthor() ? repostAvatarUrl() : avatarUrl()"
    (error)="onImageError($event)"
    alt="User avatar"
    dataTest="post-avatar"
  />
</div>
